/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { currencyFormat, idNamingConversion } from "../../../../../helpers/utilities";
import { PrimaryDrawer } from "../../Drawer/PrimaryDrawer";
import ReportModal from "../../ReportModal";
import { AutoCompleteComponent } from "../../AutoCompleteComponent";
import { useDispatch, useSelector } from "react-redux";
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import DateIcon from "../../Icons/Date";
import productSetupActions from "../../../../Product/Setup/redux/actions";
import productActions from "../../../../Product/Product/redux/actions";
import { DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import customStyles from "../../../../../assets/styles/customStyles";
import { getRequest } from '../../../../../helpers/axiosClient';
import { Button, Box, FormControlLabel, Switch } from "@mui/material";
import clsx from "clsx";
import { Space, Col, Row } from 'antd';
import moment from 'moment';

export const SalesPriceDeviation = (props) => {
    const { visible, onSalesPriceDeviationVisible, title, onMenuTitle } = props;
    const { businessDetails } = useSelector(state => state.homeReducer);
    const [salesPrice, setSalesPrice] = useState([]);
    const { myProductdetails } = useSelector(state => state.productProductReducer);
    const { productGroupDetails } = useSelector(state => state.productSetupReducer);
    const [reportOpen, setReportOpen] = useState(false);
    const [form, setForm] = useState({
        startDate: new Date(),
        endDate: new Date()
    });
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();

    const customObject = (details, id) => {
        let a = details && details.filter(function (el) { return el.id === id });
        if (a && a?.length !== 0) {
            return a[0];
        }
        return [];
    }

    const onChangeHandler = (e, name = '') => {
        if (name !== '') {
            if (name === 'productId') {
                setForm({
                    ...form,
                    'productId': '',
                    [name]: e,
                });
            } else if (name === 'groupId') {
                setForm({
                    ...form,
                    [name]: e,
                    'productId': ''
                });
            } else {
                setForm({
                    ...form,
                    [name]: e
                });
            }
        } else {
            setForm({
                ...form,
                [e.target.name]: e.target.value,
            });
        }
    }

    useEffect(() => {
        if (visible) {
            dispatch({
                type: productSetupActions.PRODUCT_GROUP_DETAILS_START, url: 'product-groups', filter: {
                    order: 'id desc'
                }
            });
            productApi();
        }
    }, [visible])


    const productApi = (search = '', id = '') => {
        let filter = { and: [{ status: 'ACTIVE' }] };
        let or = { or: [] };
        if (search !== undefined && search !== null && search !== '') {
            or['or'].push({ productName: { like: '%' + search.trim() + '%' } });
            or['or'].push({ description: { like: '%' + search.trim() + '%' } });
            or['or'].push({ productId: { like: '%' + search.trim() + '%' } });
            or['or'].push({ barcode: { like: '%' + search.trim() + '%' } });
            or['or'].push({ code: { like: '%' + search.trim() + '%' } });
        }

        if (id !== undefined && id !== null && id !== '') {
            or['or'].push({ id: id });
        }

        if (or.or.length > 0) {
            filter['and'].push(or);
        }
        dispatch({
            type: productActions.MYPRODUCT_DETAILS_START, url: 'client-products',
            filter: {
                where: filter,
                order: 'id desc',
                limit: 50,
                skip: 0
            },
        });
    }



    const salesPriceFilter = (e) => {
        e.preventDefault();
        try {
            setLoading(true);
            let url = `${process.env.REACT_APP_API_URL}/salesPriceDeviationReport?startDate=${moment(form?.startDate).format("YYYY-MM-DD")}&endDate=${moment(form?.endDate).format("YYYY-MM-DD")}`;

            if (form?.product?.id) {
                url += `&productId=${form?.product?.id}`;
            }

            if (form?.group?.id) {
                url += `&groupId=${form?.group?.id}`;
            }

            let response = getRequest(url);
            response.then(payload => {
                setSalesPrice(payload.data);
                setReportOpen(true);
                setLoading(false);
            }).catch(error => {
                // Handle any errors
                setLoading(false);
            })
        } catch (error) {
            setLoading(false);
        }

    }

    const salesPriceTitle = (form) => {
        let title = '';
        if (form?.product?.id) {
            title = 'Product Name: ' + form?.product?.productName;
        }
        if (form?.group?.id) {
            title += 'Group Name: ' + form?.group?.name;
        }
        return title;
    }

    const salesPriceDate = (form) => {
        let title = '';
        if (form?.startDate) {
            title = 'From Date: ' + moment(form?.startDate).format("DD/MM/YYYY");
        }
        if (form?.endDate) {
            title += ' To Date: ' + moment(form?.endDate).format("DD/MM/YYYY");
        }
        return title;
    }

    const handleClose = () => {
        onSalesPriceDeviationVisible(false);
        onMenuTitle('');
    }

    const classes = customStyles();
    const filteredSalesPrice = form.deviation ? salesPrice.filter(data => data.differenceAmount && data.differenceAmount !== 0) : salesPrice;

    return (
        <>
            <PrimaryDrawer
                anchor={'right'}
                open={visible}
                variant={'temporary'}
                handleClose={() => handleClose()}
                title={title}
                width={"360px"}
                className={clsx(classes.closeBackGround, classes.width100P)}
                component={
                    <Box
                        className={clsx(classes.customForm, classes.removeUnderline)}
                        component="form"
                        autoComplete="off"
                        onSubmit={(e) => salesPriceFilter(e)}>
                        <div className={classes.customFormFlex}>
                            <div className={clsx(classes.dateAdjust)}>
                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                    <DesktopDatePicker
                                        fullWidth
                                        slots={{
                                            openPickerIcon: DateIcon
                                        }}
                                        views={['year', 'month', 'day']}
                                        value={form?.startDate}
                                        format='dd/MM/yyyy'
                                        label="Start Date"
                                        InputProps={{
                                            classes: {
                                                input: classes.textFieldColor,
                                            }
                                        }}
                                        slotProps={{
                                            textField: {
                                                id: idNamingConversion('Start Date', 'customerLeaderBoard', 'TextField'),
                                                autoComplete: 'one-time-code'
                                            },
                                        }}
                                        // readOnly={true}
                                        onChange={(newValue) => {
                                            (newValue === null || newValue === 'Invalid Date') ?
                                                onChangeHandler(new Date(), 'startDate') :
                                                onChangeHandler(newValue, 'startDate')
                                        }}
                                    />
                                </LocalizationProvider>
                            </div>
                            <div className={clsx(classes.margin30t, classes.dateAdjust)}>
                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                    <DesktopDatePicker
                                        fullWidth
                                        slots={{
                                            openPickerIcon: DateIcon
                                        }}
                                        views={['year', 'month', 'day']}
                                        value={form?.endDate}
                                        format='dd/MM/yyyy'
                                        label="End Date"
                                        InputProps={{
                                            classes: {
                                                input: classes.textFieldColor,
                                            }
                                        }}
                                        slotProps={{
                                            textField: {
                                                id: idNamingConversion('End Date', 'customerLeaderBoard', 'TextField'),
                                                autoComplete: 'one-time-code'
                                            },
                                        }}
                                        // readOnly={true}
                                        onChange={(newValue) => {
                                            (newValue === null || newValue === 'Invalid Date') ?
                                                onChangeHandler(new Date(), 'endDate') :
                                                onChangeHandler(newValue, 'endDate')
                                        }}
                                    />
                                </LocalizationProvider>
                            </div>
                            <AutoCompleteComponent
                                name={`Product `}
                                heads={[{ key: "productName", name: "Product Name" },
                                { key: "code", name: "Product Code" },
                                { key: "productId", name: "Product ID" }]}
                                details={myProductdetails}
                                id={idNamingConversion("Product", "customerLeaderBoard", "DropDown")}
                                parentValue={customObject(myProductdetails, form?.product?.id)}
                                onChange={(data) => onChangeHandler(data, 'product')}
                                position="bottom"
                                searchType={(s) => productApi(s)}
                                customClasses={classes.margin20t}
                            />
                            <AutoCompleteComponent
                                name={["All Products Group"]}
                                placeholder="Please Select Products Group"
                                heads={[{ 'key': 'name', 'name': 'Name' }]}
                                details={productGroupDetails}
                                parentValue={customObject(productGroupDetails, form?.group?.id)}
                                position={"bottom"}
                                id={idNamingConversion('All Products Group', 'productAnalysis', 'DropDown')}
                                onChange={(data) => onChangeHandler(data, 'group')}
                                customClasses={classes.margin20t}
                            />
                            <FormControlLabel
                                classes={{
                                    label: clsx(classes.fonSize13, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink') // Pass your override css here
                                }}
                                id={idNamingConversion('Quantity', 'stockValue', 'Radio')}
                                control={<Switch size='small'
                                    className={clsx(classes.customSwitch)}
                                    onChange={(e) => onChangeHandler(!form.deviation, 'deviation')}
                                    checked={form.deviation}
                                />}
                                label="Show Deviation Only"
                                labelPlacement="top"
                                className={clsx(classes.marginLeft0, classes.flexStart, classes.margin20t)}
                            />
                        </div>
                        <div className={clsx(classes.btnParent)}>
                            <Space direction="horizontal" align="center">
                                <Button
                                    key="save"
                                    type="submit"
                                    color='primary'
                                    variant="contained"
                                    className={clsx(classes.modalBtn, { [classes.loading]: loading })}>OK</Button>
                                <Button
                                    key="cancel"
                                    color='primary'
                                    variant="contained"
                                    onClick={() => handleClose()}
                                    className={clsx(classes.AddMoreBtn, { [classes.loading]: loading })}>Cancel</Button>
                            </Space>
                        </div>
                    </Box>
                }
            />
            <ReportModal
                title={title}
                open={reportOpen}
                list={
                    <>
                        <div className={clsx(classes.downloadsReportHeading, classes.textAlignCenter)}>
                            <h4 className={classes.aTitle}>{title}</h4>
                            <p className={classes.downloadsHeading}>{salesPriceDate(form)}</p>
                            <p
                                className={clsx(classes.downloadsHeading)}
                                style={{ marginTop: '10px' }}>
                                {salesPriceTitle(form)}
                            </p>
                        </div>

                        <Row className={clsx(classes.bill, classes.billReportHead, classes.margin20t, classes.viewPrint, 'no-break')}>
                            <Col span={3}><h6>Pro. ID</h6></Col>
                            <Col span={4}><h6>Pro. Desc</h6></Col>
                            <Col span={3}><h6>Invoice No</h6></Col>
                            <Col span={3}><h6 >Unit Price</h6></Col>
                            <Col span={3}><h6 >Sales Price</h6></Col>
                            <Col span={3}><h6>Created</h6></Col>
                            <Col span={3}><h6>Modified</h6></Col>
                            <Col span={2}><h6>Difference</h6></Col>
                        </Row>
                        {
                            filteredSalesPrice.length > 0 ? (
                                filteredSalesPrice.map((data, i) => (
                                    <Row
                                        key={i}
                                        className={clsx(classes.bill, 'no-break')}
                                    >
                                        <Col span={3}>
                                            <p>{data.product_id}</p>
                                        </Col>

                                        <Col span={4}>
                                            <p>{data.productDescription}</p>
                                        </Col>

                                        <Col span={3}>
                                            <p>{data.invoiceNumber}</p>
                                        </Col>

                                        <Col span={3}>
                                            <p>₹ {currencyFormat(data.unitPrice)}</p>
                                        </Col>

                                        <Col span={3} >
                                            <p>₹ {currencyFormat(data.salesPrice)}</p>
                                        </Col>

                                        <Col span={3}>
                                            <p>{moment(data.createdDate).format('DD/MM/YYYY')}</p>
                                        </Col>

                                        <Col span={3}>
                                            <p>{moment(data.modifiedDate).format('DD/MM/YYYY')}</p>
                                        </Col>

                                        <Col span={2}>
                                            <p>₹ {currencyFormat(data.differenceAmount)}</p>
                                        </Col>
                                    </Row>
                                ))
                            ) : (
                                <Row className={classes.noBorder}>
                                    <Col
                                        span={24}
                                        style={{ textAlign: "center", marginTop: 15 }}
                                    >
                                        Sorry, we couldn’t find any data for the selected criteria.
                                        Please refine your filter.
                                    </Col>
                                </Row>
                            )
                        }
                        <Row className={clsx(classes.bill)}>
                            <Col span={10}>
                                <h6
                                    style={{
                                        backgroundColor: "#fff",
                                        color: "#000",
                                        fontWeight: 500,
                                        fontSize: 18
                                    }}
                                >
                                    Total:
                                </h6>
                            </Col>


                            {/* Unit Price Total */}
                            <Col span={3} >
                                <h6 style={{ backgroundColor: "#fff", color: "#000", fontWeight: 500, fontSize: 18 }}>
                                    ₹ {currencyFormat(
                                        filteredSalesPrice.reduce(
                                            (sum, row) => sum + Number(row.unitPrice || 0),
                                            0
                                        )
                                    )}
                                </h6>
                            </Col>

                            {/* Sales Price Total */}
                            <Col span={3} >
                                <h6 style={{ backgroundColor: "#fff", color: "#000", fontWeight: 500, fontSize: 18 }}>
                                    ₹ {currencyFormat(
                                        filteredSalesPrice.reduce(
                                            (sum, row) => sum + Number(row.salesPrice || 0),
                                            0
                                        )
                                    )}
                                </h6>
                            </Col>

                            {/* Created Date */}
                            <Col span={3}></Col>

                            {/* Modified Date */}
                            <Col span={3}></Col>

                            {/* Difference Total */}
                            <Col span={2}>
                                <h6 style={{ backgroundColor: "#fff", color: "#000", fontWeight: 500, fontSize: 18 }}>
                                    ₹ {currencyFormat(
                                        filteredSalesPrice.reduce(
                                            (sum, row) => sum + Number(row.differenceAmount || 0),
                                            0
                                        )
                                    )}
                                </h6>
                            </Col>
                        </Row>
                    </>
                }
                businessDetails={businessDetails}
                handleClose={() => { setReportOpen(false); setSalesPrice([]) }}
            />
        </>
    )
}